import currency from '@/filters/currency';
import { ROUTER_PATHS } from '@/router/constants';
import { BASE_URL_PROD } from '@/constants';

export default {
  privateInfo(state) {
    return state.data;
  },
  privateInfoSavingStatus(state) {
    return state.saving;
  },
  privateInfoLoading(state) {
    return state.loading;
  },
  googleId(state, getters) {
    // eslint-disable-next-line camelcase
    return getters.privateInfo?.google_gid || null;
  },
  referrals(state, getters) {
    return getters.privateInfo?.referrals || [];
  },
  lastReferral(state, getters) {
    return getters.referrals[getters.referrals.length - 1] || null;
  },
  referralReward(state, getters) {
    const reward = getters.lastReferral?.reward || 0;
    return currency(reward);
  },
  referralLink(state, getters) {
    const code = getters.lastReferral?.code || null;
    const url = `${BASE_URL_PROD}/#${ROUTER_PATHS.SIGN_UP}?referralCode=${code}`;

    return url;
  },
  balance(state, getters) {
    return getters.privateInfo.balance;
  },
};
